import React, { useContext, useEffect, useRef, useState, useCallback } from 'react'
import axios from '../../../config/axios'
import { useTenant } from '../../../contexts/TenantContext'
import { Content } from './style'
import { OptionsButton, LeftSide, RightSide, SectionName, SubHeaderContainer, Tab, TabsDiv, ButtonCreate, RefreshIcon, RefreshIconContainer, FilterWrapper } from '../../../components/styles/subheader-style'
import stock from '../../../assets/stock/TableMovementHeader/list-active.svg'
import movement from '../../../assets/stock/TableMovementHeader/refresh-active.svg'
import { Outlet, useNavigate, useOutletContext, useLocation } from 'react-router-dom'
import ModalContext from '../../../contexts/ModalContext'
import { TypeMainOutlet } from '..'
import { tableFields, fashionStockDefault } from '../../../components/FieldManager/table-fields'
import FieldsManager, { FieldsManagerType } from '../../../components/FieldManager'
import WithoutSelectedFields from '../../SystemErrors/WithoutSelectedFields'
import StockContext from '../../../contexts/StockContext'
import FilterMenu from '../../../components/SubHeaderFilter/FilterMenu'
import AppliedFiltersDisplay from '../../../components/SubHeaderFilter/AppliedFiltersDisplay'
import { Header, Filter } from '../../../components/SubHeaderFilter/types'
import { ArrowDown, Filter as FilterIcon } from 'lucide-react'
import { useUserPreferences } from '../../../contexts/UserPreferencesContext'

export const stockFilterHeaders: Header[] = [
  { key: 'isActivated', label: 'Disponível', type: 'boolean' },
  { key: 'code', label: 'Código', type: 'string' },
  { key: 'material', label: 'Material', type: 'string' },
  { key: 'color', label: 'Cor', type: 'string' },
  { key: 'description', label: 'Descrição', type: 'string' },
  { key: 'quantities', label: 'Quantidade', type: 'string' },
  { key: 'prices', label: 'Preço', type: 'price' },
  { key: 'format', label: 'Formato', type: 'string' },
  { key: 'finishing', label: 'Acabamento', type: 'string' },
  { key: 'fabrication', label: 'Fabricação', type: 'string' },
  { key: 'heatTreatment', label: 'Tratamento Térmico', type: 'string' },
  { key: 'originCountry', label: 'País de origem', type: 'string' },
  { key: 'supplier', label: 'Fornecedor', type: 'string' },
  { key: 'stockStreet', label: 'Rua', type: 'string' },
  { key: 'shelf', label: 'Prateleira', type: 'string' },
  { key: 'stockLocation', label: 'Localização', type: 'string' },
  { key: 'ncm', label: 'Ncm', type: 'string' },
  { key: 'dimension1', label: 'Dimensão 1 (mm)', type: 'number' },
  { key: 'dimension2', label: 'Dimensão 2 (mm)', type: 'number' },
  { key: 'invoice', label: 'Nota Fiscal', type: 'string' },
  { key: 'density', label: 'Densidade', type: 'number' },
  { key: 'certificateUrl', label: 'Certificados', type: 'string' },
  { key: 'totalCmc', label: 'Total CMC', type: 'number' },
  { key: 'trackingNumber', label: 'Número de Rastreamento', type: 'string' },
  { key: 'receivedDate', label: 'Data de Recebimento', type: 'date' },
  { key: 'purchaseOrder', label: 'Ordem de Compra', type: 'string' },
  { key: 'heatNumber', label: 'Número da Corrida', type: 'string' },
  { key: 'family', label: 'Família', type: 'string' },
  { key: 'characteristic', label: 'Característica', type: 'string' },
  { key: 'carrierCode', label: 'Código da transportadora', type: 'string' }
]

export const resourceFilterHeaders: Header[] = [
  { key: 'name', label: 'Insumo/Aviamento', type: 'string' },
  { key: 'code', label: 'Código', type: 'string' },
  { key: 'category', label: 'Categoria', type: 'string' },
  { key: 'type', label: 'Tipo', type: 'string' },
  { key: 'color', label: 'Cor', type: 'string' },
  { key: 'description', label: 'Descrição', type: 'string' },
  { key: 'stockUnit', label: 'Unidade', type: 'string' },
  { key: 'totalWeight', label: 'Peso (kg)', type: 'number' },
  { key: 'lengthInMm', label: 'Comprimento (mm)', type: 'number' },
  { key: 'unitQuantity', label: 'Quantidade', type: 'number' },
  { key: 'dimension1', label: 'Dimensão 1', type: 'number' },
  { key: 'dimension2', label: 'Dimensão 2', type: 'number' },
  { key: 'supplier', label: 'Fornecedor', type: 'string' },
  { key: 'isActivated', label: 'Status', type: 'boolean' }
]

import TableFiltersContext from '../../../contexts/TableFiltersContext'
import SectionContext from '../../../contexts/SectionContext'
import refresh_act from '../../../assets/refresh-active.svg'
import resource from '../../../assets/home/resource.svg'
import receipt from '../../../assets/home/receipt.svg'
import steel from '../../../assets/home/steel.svg'
import { CompanyTypes, FilterTypesDiv } from '../../../components/Stock/TableMovementHeader/style'
import { stockHeaders, movementHeaders, resourceHeaders } from './utils'
import ProductFinals from '../ProductFinal'
import SalesStockDashboard, { SalesStockToolbar, useSalesStockState } from './SalesStock'
import { usePersistedFilters } from '../../../hooks/usePersistedFilters'

export interface StockOutletType {
  tabIndex: number
  setTabIndex: React.Dispatch<React.SetStateAction<number>>
  fields: FieldsManagerType
  setFields: React.Dispatch<React.SetStateAction<FieldsManagerType>>
  isdropdownOpen: boolean
  setIsDropdownOpen: React.Dispatch<React.SetStateAction<boolean>>
  quantity: number
  setQuantity: React.Dispatch<React.SetStateAction<number>>
}

const steelTabs = [
  { path: '/panel/stock', image: stock, name: 'Matéria prima', external: false },
  { path: '/panel/resource', image: resource, name: 'Insumos', external: false },
  { path: '/panel/product-final', image: steel, name: 'Produto engenheirado', external: true }
]

const fashionTabs = [
  { path: '/panel/stock', image: stock, name: 'Tecidos', external: false },
  { path: '/panel/stock/resource', image: resource, name: 'Aviamentos', external: false },
  { path: '/panel/stock/sales', image: receipt, name: 'Vendas', external: false }
]

interface StockSubHeaderProps {
  tabIndexActived: number
  handleTabChange: (index: number) => void
  salesStockState?: ReturnType<typeof useSalesStockState>
  appliedFilters: Filter[]
  onApplyFilter: (f: Filter) => void
  stockSection: 'stock' | 'movement' | 'resource' | 'sales'
  useMyPrefs?: boolean
  useMyPrefsKey?: string
}

const StockSubHeader: React.FC<StockSubHeaderProps> = ({
  tabIndexActived,
  handleTabChange,
  salesStockState,
  appliedFilters,
  onApplyFilter,
  stockSection,
  useMyPrefs,
  useMyPrefsKey
}) => {
  const navigate = useNavigate()
  const { setModalActive, setModalSection, setStockMode } = useContext(ModalContext)
  const { resetContext, setRefresh: setContextRefresh, isLoading } = useContext(StockContext)
  const [isFilterMenuOpen, setIsFilterMenuOpen] = useState(false)
  const filterButtonRef = useRef<HTMLDivElement | null>(null)
  const [stockInfo, setStockInfo] = useState({ totalWeight: 0, totalItems: 0 })

  const fetchStockInfo = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_GATEWAY_BASE_URL}/backend/stock/getTotalStock`);
      setStockInfo(response.data);
    } catch (error) {
      console.error('Erro ao buscar dados do estoque:', error);
    }
  };

  useEffect(() => {
    fetchStockInfo();
  }, []);

  const openModal = () => {
    resetContext()
    if (isFashionTenant) {
      setStockMode('fashion')
    }
    setModalActive(true)
    setModalSection('addStockMenu')
  }

  const openExportModal = () => {
    navigate('/panel/stock/export')
  }

  const { isFashionTenant } = useTenant()
  const visibleTabs = isFashionTenant ? fashionTabs : steelTabs

  const filteredHeaders = stockFilterHeaders.filter(header => {
    if (isFashionTenant) {
      return !['density', 'heatTreatment'].includes(header.key)
    } else {
      return header.key !== 'color'
    }
  })

  const filteredResourceHeaders = resourceFilterHeaders.filter(header => {
    if (isFashionTenant) {
      return true
    } else {
      return header.key !== 'color'
    }
  })

  const headers = tabIndexActived === 1
    ? filteredResourceHeaders
    : (stockSection === 'movement' ? movementHeaders : filteredHeaders)

  const { setPreference, isTenantAdmin } = useUserPreferences()

  return (
    <SubHeaderContainer>
      <LeftSide>
        <SectionName title={`Peso total: ${stockInfo.totalWeight.toLocaleString('pt-BR', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })} kg\nItens totais: ${stockInfo.totalItems}`}>Estoque</SectionName>
        <TabsDiv>
          {visibleTabs.map((tab, index) => {
            const isFirst = index === 0
            const isLast = index === visibleTabs.length - 1
            return (
              <Tab
                key={index}
                $isFirst={isFirst}
                $isLast={isLast}
                $isActive={index === tabIndexActived}
                onClick={() => {
                  if (index !== tabIndexActived) {
                    handleTabChange(index)
                    navigate(tab.path)
                  }
                }}
              >
                <img src={tab.image} alt={`${tab.path}-icon`} />
                {tab.name}
              </Tab>
            )
          })}
        </TabsDiv>
        {!isTenantAdmin && useMyPrefsKey && (
          <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '12px', fontWeight: 600, color: '#696969', marginLeft: '16px', cursor: 'pointer' }}>
            <input
              type="checkbox"
              checked={useMyPrefs}
              onChange={(e) => setPreference(useMyPrefsKey, e.target.checked)}
              style={{ width: '16px', height: '16px', accentColor: '#0090D3', cursor: 'pointer' }}
            />
            Utilizar minhas preferências
          </label>
        )}
      </LeftSide>
      <RightSide>
        {tabIndexActived === 2 && salesStockState ? (
          <SalesStockToolbar state={salesStockState.toolbarState} />
        ) : (
          <>
            {tabIndexActived === 0 ? (
              <RefreshIconContainer onClick={() => setContextRefresh((prev: boolean) => !prev)} title="Atualizar">
                <RefreshIcon src={refresh_act} alt="Movement icon" $spinning={!!isLoading} />
              </RefreshIconContainer>
            ) : null}
            {tabIndexActived === 0 || tabIndexActived === 1 ? (
              <FilterWrapper>
                <OptionsButton ref={filterButtonRef} onClick={() => setIsFilterMenuOpen(true)}>
                  <FilterIcon size={18} />
                </OptionsButton>
                {isFilterMenuOpen && (
                  <FilterMenu
                    headers={headers}
                    onApplyFilter={(f) => {
                      onApplyFilter(f)
                      setIsFilterMenuOpen(false)
                    }}
                    onClose={() => setIsFilterMenuOpen(false)}
                    anchorRef={filterButtonRef}
                    filters={appliedFilters}
                  />
                )}
              </FilterWrapper>
            ) : null}
            {tabIndexActived === 1 ? (
              <ButtonCreate onClick={() => navigate('/panel/stock/resource/create')}>+ {isFashionTenant ? 'Adicionar Aviamento' : 'Adicionar Insumo'}</ButtonCreate>
            ) : null}
            {tabIndexActived === 0 ? (
              <>
                <ButtonCreate onClick={() => openExportModal()}>Exportar estoque</ButtonCreate>
                <ButtonCreate onClick={() => openModal()}>+ {isFashionTenant ? 'Adicionar Tecido' : 'Adicionar Estoque'}</ButtonCreate>
              </>
            ) : null}
          </>
        )}
      </RightSide>
    </SubHeaderContainer>
  )
}

const StockContent = () => {
  const { getPreference, getEffectivePreference, setPreference, isTenantAdmin, isLoading: isPrefsLoading } = useUserPreferences()
  const [isdropdownOpen, setIsDropdownOpen] = useState(false)
  const location = useLocation()
  const [tabIndex, setTabIndex] = useState<number>(0)
  const { search } = useOutletContext<TypeMainOutlet>()
  const { stockFilters, movementFilters, setStockFilters, setMovementFilters } = useContext(TableFiltersContext)
  const { stockSection } = useContext(SectionContext)
  const { stockList, hasMoreStock, isLoading } = useContext(StockContext)
  const { stockMode } = useContext(ModalContext)
  const { isFashionTenant } = useTenant()
  const isFashion = isFashionTenant || stockMode === 'fashion'
  const salesStock = useSalesStockState(isFashionTenant)
  const fashionHiddenFields = ['heatTreatment', 'density']
  const [quantity, setQuantity] = useState(50)

  const stockFiltersState = usePersistedFilters(isFashion ? 'stock_current_fashion' : 'stock_current_steel')
  const movementFiltersState = usePersistedFilters(isFashion ? 'stock_movement_fashion' : 'stock_movement_steel')
  const resourceFiltersState = usePersistedFilters(isFashion ? 'stock_resource_fashion' : 'stock_resource_steel')

  const activeFiltersState = (section: string) => {
    if (section === 'resource') return resourceFiltersState
    if (section === 'movement') return movementFiltersState
    return stockFiltersState
  }

  useEffect(() => {
    const mapped = stockFiltersState.appliedFilters.flatMap(f => {
      if (f.filterType === 'Intervalo' && f.value?.start && f.value?.end) {
        return [
          { field: f.label, type: 'É maior/igual que', text: f.value.start },
          { field: f.label, type: 'É menor/igual que', text: f.value.end }
        ]
      }
      let typeMapped = f.filterType
      if (f.filterType === 'equals') typeMapped = 'É igual a'
      else if (f.filterType === 'contains') typeMapped = 'Contém'
      else if (f.filterType === 'startsWith') typeMapped = 'Começa com'
      else if (f.filterType === 'endsWith') typeMapped = 'Acaba com'
      else if (f.filterType === 'not') typeMapped = 'É diferente de'
      else if (f.filterType === 'gt') typeMapped = 'É maior que'
      else if (f.filterType === 'lt') typeMapped = 'É menor que'
      else if (f.filterType === 'gte') typeMapped = 'É maior/igual que'
      else if (f.filterType === 'lte') typeMapped = 'É menor/igual que'
      else if (f.filterType === 'Antes de') typeMapped = 'É menor que'
      else if (f.filterType === 'Depois de') typeMapped = 'É maior que'
      else if (f.filterType === 'Igual a') typeMapped = 'É igual a'
      else if (f.filterType === 'Diferente de') typeMapped = 'É diferente de'
      else if (f.filterType === 'Maior que') typeMapped = 'É maior que'
      else if (f.filterType === 'Menor que') typeMapped = 'É menor que'

      let val = f.value
      if (f.fieldType === 'boolean') {
        val = f.value === 'true' || f.value === true
      }
      return [{ field: f.label, type: typeMapped, text: typeof val === 'object' && val !== null ? val : String(val) }]
    })
    setStockFilters(mapped)
  }, [stockFiltersState.appliedFilters, setStockFilters])

  useEffect(() => {
    const mapped = movementFiltersState.appliedFilters.flatMap(f => {
      if (f.filterType === 'Intervalo' && f.value?.start && f.value?.end) {
        return [
          { field: f.label, type: 'É maior/igual que', text: f.value.start },
          { field: f.label, type: 'É menor/igual que', text: f.value.end }
        ]
      }
      let typeMapped = f.filterType
      if (f.filterType === 'equals') typeMapped = 'É igual a'
      else if (f.filterType === 'contains') typeMapped = 'Contém'
      else if (f.filterType === 'startsWith') typeMapped = 'Começa com'
      else if (f.filterType === 'endsWith') typeMapped = 'Acaba com'
      else if (f.filterType === 'not') typeMapped = 'É diferente de'
      else if (f.filterType === 'gt') typeMapped = 'É maior que'
      else if (f.filterType === 'lt') typeMapped = 'É menor que'
      else if (f.filterType === 'gte') typeMapped = 'É maior/igual que'
      else if (f.filterType === 'lte') typeMapped = 'É menor/igual que'
      else if (f.filterType === 'Antes de') typeMapped = 'É menor que'
      else if (f.filterType === 'Depois de') typeMapped = 'É maior que'
      else if (f.filterType === 'Igual a') typeMapped = 'É igual a'
      else if (f.filterType === 'Diferente de') typeMapped = 'É diferente de'
      else if (f.filterType === 'Maior que') typeMapped = 'É maior que'
      else if (f.filterType === 'Menor que') typeMapped = 'É menor que'

      let val = f.value
      if (f.fieldType === 'boolean') {
        val = f.value === 'true' || f.value === true
      }
      return [{ field: f.label, type: typeMapped, text: typeof val === 'object' && val !== null ? val : String(val) }]
    })
    setMovementFilters(mapped)
  }, [movementFiltersState.appliedFilters, setMovementFilters])

  // Chaves separadas de localStorage para modo industrial e fashion
  const localStorageKey = isFashion ? 'tableFieldsFashion' : 'tableFields'
  const useMyPrefsKey = `useMyPreferences_${localStorageKey}`
  const useMyPrefs = getPreference<boolean>(useMyPrefsKey, false)
  const fromLocalStorage = getEffectivePreference<FieldsManagerType[] | undefined>(localStorageKey)

  const sanitizeStockFields = (fieldsToSanitize: FieldsManagerType, isFashionMode: boolean): FieldsManagerType => {
    const forbiddenFields = [
      'quantity',
      'totalWeight',
      'lengthInMm',
      'costPerKg',
      'costPerMm',
      'totalCost',
      'measurementUnit',
      'nf',
      'certificateNumber'
    ]
    let cleanList = fieldsToSanitize.whichFieldsToShow.filter(f => !forbiddenFields.includes(f.field))
    
    cleanList = cleanList.map(f => {
      if (f.field === 'quantities') return { ...f, fieldName: 'Conjunto de Quantidades' }
      if (f.field === 'prices') return { ...f, fieldName: 'Conjunto de Preço' }
      return f
    })

    cleanList = cleanList.filter(f => f.field !== 'isActivated')
    cleanList.unshift({ checked: true, field: 'isActivated', fieldName: 'Disponível' })

    if (!cleanList.some(f => f.field === 'quantities')) {
      cleanList.push({ checked: true, field: 'quantities', fieldName: 'Conjunto de Quantidades' })
    }
    if (!cleanList.some(f => f.field === 'prices')) {
      cleanList.push({ checked: true, field: 'prices', fieldName: 'Conjunto de Preço' })
    }
    if (!cleanList.some(f => f.field === 'description')) {
      cleanList.push({ checked: true, field: 'description', fieldName: 'Descrição' })
    }
    if (!cleanList.some(f => f.field === 'carrierCode')) {
      cleanList.push({ checked: false, field: 'carrierCode', fieldName: 'Código da transportadora' })
    }

    return {
      ...fieldsToSanitize,
      whichFieldsToShow: cleanList
    }
  }

  // Se não há nada no localStorage, usa o default correto para o modo atual
  const defaultFromTable = isFashion
    ? fashionStockDefault
    : (tableFields.find(field => field.tableSection === 'stock') || tableFields[0])

  const tableFieldsJson: FieldsManagerType[] = fromLocalStorage
    ? (typeof fromLocalStorage === 'string' ? JSON.parse(fromLocalStorage) : fromLocalStorage)
    : (isFashion ? [fashionStockDefault] : tableFields)

  let foundFields = tableFieldsJson.find(field => field.tableSection === 'stock')

  if (isFashion && foundFields) {
    const hasColorField = foundFields.whichFieldsToShow.some(field => field.field === 'color')
    if (!hasColorField) {
      foundFields = fashionStockDefault
    }
  }

  if (foundFields) {
    foundFields = sanitizeStockFields(foundFields, isFashion)
  }
  const cleanDefaultFromTable = sanitizeStockFields(defaultFromTable, isFashion)

  const defaultFields = (foundFields && foundFields.whichFieldsToShow.some(field => field.checked))
    ? foundFields
    : cleanDefaultFromTable
  const [section, setSection] = useState<'stock' | 'movement' | 'resource' | 'sales'>('stock')
  const [fields, setFields] = useState<FieldsManagerType>(defaultFields as FieldsManagerType)
  const headerTabIndex = section === 'resource' ? 1 : section === 'sales' ? 2 : 0

  const handleSaveFields = useCallback((value: React.SetStateAction<FieldsManagerType>) => {
    setFields((prev) => {
      const newFields = typeof value === 'function' ? (value as any)(prev) : value

      const currentPreferences = fromLocalStorage || (isFashion ? [fashionStockDefault] : tableFields)
      const toLocalStorage = currentPreferences.map((table: FieldsManagerType) => {
        if (table.tableSection === section) {
          return { ...table, whichFieldsToShow: newFields.whichFieldsToShow }
        }
        return table
      })

      setTimeout(() => {
        setPreference(localStorageKey, toLocalStorage)
        if (!isTenantAdmin) {
          setPreference(useMyPrefsKey, true)
        }
      }, 0)
      return newFields
    })
  }, [fromLocalStorage, isFashion, section, localStorageKey, isTenantAdmin, useMyPrefsKey, setPreference])

  useEffect(() => {
    if (isPrefsLoading) return
    if (section === 'resource') {
      setIsDropdownOpen(false)
      return
    }
    const updatedFields = tableFieldsJson.find(field => field.tableSection === section)
    const defaultSectionFields = isFashion
      ? fashionStockDefault
      : tableFields.find(field => field.tableSection === section)

    let fieldsToUse = (updatedFields && updatedFields.whichFieldsToShow.some(field => field.checked))
      ? updatedFields
      : defaultSectionFields

    if (fieldsToUse) {
      fieldsToUse = sanitizeStockFields(fieldsToUse, isFashion)
    }

    if (isFashion && section === 'stock' && fieldsToUse) {
      const hasColorField = fieldsToUse.whichFieldsToShow.some(field => field.field === 'color')
      if (!hasColorField) {
        fieldsToUse = fashionStockDefault
      }
    }

    if (fieldsToUse && JSON.stringify(fieldsToUse) !== JSON.stringify(fields)) {
      setFields(fieldsToUse)
    }
  }, [section, isPrefsLoading, fromLocalStorage, isFashion])

  useEffect(() => {
    const basePath = '/panel/stock'
    if (!location.pathname.startsWith(basePath)) {
      setSection('stock')
      setTabIndex(0)
      return
    }

    const remainder = location.pathname.slice(basePath.length)
    const segments = remainder.split('/').filter(segment => segment.length > 0)
    const primarySegment = segments[0] || ''

    if (primarySegment === 'movement') {
      setSection('movement')
      setTabIndex(0)
      return
    }

    if (['resource', 'create', 'edit', 'view'].includes(primarySegment)) {
      setSection('resource')
      setTabIndex(1)
      return
    }

    if (primarySegment === 'sales') {
      setSection('sales')
      setTabIndex(2)
      return
    }

    setSection('stock')
    setTabIndex(0)
  }, [location.pathname])

  const handleTabSelection = (index: number) => {
    if (index === 2 && isFashionTenant) {
      setSection('sales')
      setTabIndex(2)
      return
    }

    if (index === 1) {
      setSection('resource')
      setTabIndex(1)
      return
    }

    if (index === 0) {
      setSection('stock')
      setTabIndex(0)
      return
    }

    setTabIndex(index)
  }

  const renderSubHeader = () => {
    if (location.pathname.includes('panel/product-final')) {
      return <ProductFinals />
    }
    return (
      <StockSubHeader
        tabIndexActived={headerTabIndex}
        handleTabChange={handleTabSelection}
        salesStockState={section === 'sales' ? salesStock : undefined}
        appliedFilters={activeFiltersState(section).appliedFilters}
        onApplyFilter={activeFiltersState(section).handleApplyFilter}
        stockSection={section}
        useMyPrefs={useMyPrefs}
        useMyPrefsKey={useMyPrefsKey}
      />
    )
  }

  const shouldShowFieldManager = section !== 'resource' && section !== 'sales'
  const hasSelectedFields = fields?.whichFieldsToShow?.some(field => field.checked)

  const outletContext = {
    tabIndex,
    setTabIndex,
    search,
    fields,
    setFields: handleSaveFields,
    isdropdownOpen,
    setIsDropdownOpen,
    quantity,
    setQuantity,
    appliedFilters: section === 'resource' ? resourceFiltersState.appliedFilters : [],
  }

  return (
    <>
      {renderSubHeader()}
      {(section === 'stock' || section === 'movement' || section === 'resource') && (
        <AppliedFiltersDisplay
          filters={activeFiltersState(section).appliedFilters}
          onRemoveFilter={activeFiltersState(section).handleRemoveFilter}
          onClearAll={activeFiltersState(section).handleClearAll}
        />
      )}
      <Content>
        {section === 'sales' ? (
          <SalesStockDashboard
            state={salesStock.toolbarState}
            items={salesStock.items}
            filtered={salesStock.filtered}
            isLoading={salesStock.isLoading}
            expandedGroups={salesStock.expandedGroups}
            setExpandedGroups={salesStock.setExpandedGroups}
          />
        ) : shouldShowFieldManager && !hasSelectedFields ? (
          <WithoutSelectedFields dropdown={setIsDropdownOpen} />
        ) : (
          <Outlet context={outletContext} />
        )}
      </Content>
    </>
  )
}

export const StockResourceLayout = () => {
  const context = useOutletContext<any>()
  return <Outlet context={{ ...context }} />
}

export default StockContent